import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OldCarQuotationComponent } from './components/old-car-quotation/old-car-quotation.component';
import { ButtonModule } from '@sc/portal.fe.lib.ui-core-components';
import { PipesModule } from 'app/shared/pipes/pipes.module';



@NgModule({
  declarations: [OldCarQuotationComponent],
  exports: [OldCarQuotationComponent],
  imports: [
    CommonModule,
    ButtonModule,
    PipesModule,
  ]
})
export class OldCarQuotationModule { }
